import moment from 'moment';

import { Post as API } from '@src/api/types';
import { Post as Data } from '@src/types';

import generateMedia from './media';
import generatePlaceTag from './placeTag';
import generateUser from './user';

const Factory = (api: API): Data => ({
  id: api.id,
  content: api.description,
  date: moment.unix(api.date / 1000),
  user: generateUser(api.user),
  place: generatePlaceTag(api.business),
  journey: api.journey
    ? {
        id: api.journey.id,
        name: api.journey.title,
      }
    : undefined,
  medias: api.medias.map((media) => generateMedia(media)),
  likesCount: api.likesCount,
  liked: api.liked,
  commentsCount: api.commentsCount,
});

export default Factory;
